import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as CommentSvg } from './assets/comment-dots.svg';

const CommentDotsIcon = React.forwardRef((args, ref) => <SvgIcon component={CommentSvg} ref={ref} {...args} />);

export default CommentDotsIcon;
